import React, { useEffect, useState } from "react";

import { ColorResult } from "react-color";

import { ElementState, Preview } from "@creatomate/preview";

import { Trans } from "app/utils";
import general from "constants/general";
import ColorPicker from "../ColorPicker";
import getRgbColor from "../../utils/getRgbColor";
import getRgbObjFromString from "../../utils/getRgbObjFromString";
import getHexFromRgbObject from "../../utils/getHexFromRgbObject";
import getHslFromRgba from "../../utils/getHslFromRgba";
import { isSubtitleText } from "../../sidebar/tabs/subtitle/utils";


interface FillColorProps {
  activeElement: ElementState;
  disabled?: boolean;
  onSubtitleChange?: (color: ColorResult) => Promise<void>;
  preview: Preview;
}

const FillColor: React.FC<FillColorProps> = ({
  activeElement,
  disabled,
  onSubtitleChange,
  preview
}) => {
  const [color, setColor] = useState<ColorResult>(general.DEFAULT_COLOR);

  useEffect(
    () => {
      const getFontColor = () => {
        const { fill_color: color } = activeElement.source;
        const rgbaObj = getRgbObjFromString(color);
        setColor(color
          ? {
            hex: getHexFromRgbObject(rgbaObj),
            rgb: rgbaObj,
            hsl: getHslFromRgba(rgbaObj)
          } : general.DEFAULT_COLOR
        );
      };

      if (activeElement.source.type === "text") {
        getFontColor();
      }
    }, [activeElement]
  );

  const handleColorChange = async (color: ColorResult) => {
    setColor(color);
    if (onSubtitleChange) {
      await onSubtitleChange(color);
    } else {
      await preview.applyModifications({
        [`${activeElement.source.id}.fill_color`]: getRgbColor(color)
      });
    }
  };

  return (
    <div className="ColorField">
      <div>
        <span className="chq-ffd--lb"><Trans>Font Color</Trans></span>
      </div>
      <ColorPicker disabled={disabled} initialColor={color} onChangeColor={handleColorChange} />
    </div>
  );
};

export default FillColor;
